import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SubscriptionsManager } from '../util/subscriptions-manager';
import { ScaleService } from '../ontology/service/scale.service';

@Component({
    selector: 'jhi-column-filter-scales',
    template: `
		<form #f='ngForm'>
			<section class="filter-wrapper">
				<div class="keyword-wrapper">
					<input type="text" class="form-control" [formControl]="queryField" id="keyword" placeholder="{{ scalesPlaceholder | translate }}" autofocus/>
				</div>
				<ul class="filter-select">
					@if (results.length > 0) {
						<li *ngFor="let result of results" class="filter-select-list" (click)="addScale(result)">
							<div class="result-line mt-2 ms-2">
								<span class="label-info fw-bold">{{ 'column-filter.name' | translate }}:</span>
								<span>{{ result.name }}</span>
							</div>
							<div class="result-line ms-2">
								<span class="label-info fw-bold">{{ 'column-filter.description' | translate }}:</span>
								<span class="result-value">{{ result.description }}</span>
							</div>
						</li>
					}
				</ul>
			</section>
			@if (filter.scales.length === 0) {
				<div class="empty-selection">
					<span>{{ 'column-filter.scales.label' | translate }}</span>
				</div>
			} @else {
				<div class="selected-items-container mt-2">
					<div *ngFor="let scale of filter.scales" class="selected-chip">
						<button type="button" class="chip-remove" (click)="deleteScale(scale)" aria-label="Remove scale"> ×</button>
						<span class="chip-text">{{ scale.name }}</span>
					</div>
				</div>
			}
			<br/>
			<div class="footer text-center">
				<br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button type="button" class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterScalesComponent implements OnInit, OnDestroy {

    queryField: FormControl = new FormControl();
    results: any[] = [];

    @Input() filter: any;
    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();
    scalesPlaceholder: string;

    subscriptionManager = new SubscriptionsManager();

    constructor(private scaleService: ScaleService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.queryField.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((query) => this.scaleService.queryScales(query))
            ).subscribe((result) => {
                if (result.status === 400) {
                    this.results = [];
                    return;
                }
                this.results = result.body || [];
            });
        this.scalesPlaceholder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.search.text.placeholder';
    }

    addScale(scale) {
        // Reset query field value
        this.queryField.setValue('');
        // Do not add scales if it's already in the list
        if (!this.filter.scales.some((e) => e.name === scale.name)) {
            this.filter.scales.push({ ...scale });
        }
    }

    deleteScale(scale) {
        this.filter.scales = this.filter.scales.filter((e) => e.name !== scale.name);
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
